import { z } from 'zod';

import type { TFunction } from 'i18next';

import { CASHIER_TERMINAL_PROTOCOL } from '@/constants';

export function createCashierTerminalFormSchema(t: TFunction) {
  return z
    .object({
      name: z
        .string({ message: t('validation_required') })
        .min(1, { message: t('validation_required') })
        .trim(),
      location_id: z
        .string({ message: t('validation_required') })
        .min(1, { message: t('validation_required') }),
      cashier_id: z
        .string({ message: t('validation_required') })
        .min(1, { message: t('validation_required') }),
      mac_address: z
        .string({ message: t('validation_required') })
        .min(1, { message: t('validation_required') })
        .regex(/^([0-9A-Fa-f]{2}:){5}[0-9A-Fa-f]{2}$/, {
          message: t('Invalid MAC address format'),
        }),
      model: z.string().optional(),
      bank: z.string().optional(),
      protocol: z
        .string({ message: t('validation_required') })
        .min(1, { message: t('validation_required') }),
      port: z
        .string({ message: t('validation_required') })
        .min(1, { message: t('validation_required') })
        .refine(
          (value) => {
            const n = Number(value);
            return Number.isInteger(n) && n >= 1 && n <= 65535;
          },
          {
            message: t('Port must be between {{min}} and {{max}}', {
              min: 1,
              max: 65535,
            }),
          },
        ),
      merchant_id: z.string().optional(),
      notes: z.string().optional(),
    })
    .superRefine((values, ctx) => {
      if (
        values.protocol === CASHIER_TERMINAL_PROTOCOL.SSI_JSON &&
        !values.merchant_id?.trim()
      ) {
        ctx.addIssue({
          code: 'custom',
          path: ['merchant_id'],
          message: t('Merchant ID is required for SSI JSON terminals'),
        });
      }
    });
}

export type CashierTerminalFormValues = z.infer<
  ReturnType<typeof createCashierTerminalFormSchema>
>;
